import React from "react";
import {GlobalContext} from "../../GlobalContext";
import GroupLiensMonthSummary from "./GroupLiensMonthSummary";

export default class GroupLiensList extends React.Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);

        this.state = {
            months: []
        }
    }

    componentDidMount() {
        this.loadHistory();
    }

    loadHistory = () => {
        if (this.props.groupId) {
            this.context.apiRequest("GET", `/liens/history/group/${this.props.groupId}?monthsBack=24`)
                .then(resp => {
                    if (resp && resp.data) {
                        this.setState({months: resp.data});
                    }
                })
        }
    }

    render() {
        return this.state.months.map(m => <GroupLiensMonthSummary month={m} key={m.displayName}/>)
    }
}